import { Component, OnInit, AfterViewInit } from '@angular/core';
import { UserSettingsService } from '../user-settings/user-settings.service';
import * as _ from 'underscore';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
@Component({
  selector: 'app-user-settings',
  templateUrl: './user-settings.component.html',
  styleUrls: ['./user-settings.component.css']
})
export class UserSettingsComponent implements OnInit, AfterViewInit {
  name;
  userObj;
  createdDate;
  constructor(private userSettingsService: UserSettingsService,  private router: Router) {
    // this.name = this.userSettingsService.userName ? this.userSettingsService.userName : 'Sam';
   }

  ngOnInit() {
  //   window.addEventListener('popstate', function(event) {
  //     // history.pushState(null, null, 'no-back-button');
  // });

 
      this.userSettingsService.getUserObj
      .subscribe((data) => {
        if (data['userObj']) {

          this.userObj = data['userObj'].user;
          //if(sessionStorage.getItem('loginUserId') == this.userObj._id)
         // {
            
            this.name = this.userObj.fName + ' ' + this.userObj.lName;
            // to set the created date
            if (!_.isEmpty(this.userObj)) {
              this.createdDate = this.userObj.createdDate;
            }
          // }
          // else
          // {
          //   sessionStorage.clear();
          //   this.router.navigate(['/login']);
          // }
        }
      });
 
    
  }
  ngAfterViewInit(): void {
  //   window.addEventListener('popstate', function(event) {
  //      history.pushState(null, null, 'no-back-button');
  // });
    $('.navbar-toggler').click(function () {
      $('.navbar').toggleClass('parent');
    });
  }
}
